/**
 * Bison Promise — video modal (YouTube, Vimeo, direct file, or generic iframe URL).
 */
(function () {
  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function parseVideoUrl(url) {
    if (!url || typeof url !== 'string') return null;
    url = url.trim();
    if (!url) return null;

    var m = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/
    );
    if (m) return { type: 'youtube', id: m[1] };

    m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return { type: 'vimeo', id: m[1] };

    if (/\.(mp4|webm|ogg)(\?|#|$)/i.test(url)) return { type: 'video', src: url };

    return { type: 'iframe', src: url };
  }

  function buildEmbed(parsed) {
    if (!parsed) return '';
    if (parsed.type === 'youtube') {
      return (
        '<iframe src="https://www.youtube.com/embed/' +
        escapeAttr(parsed.id) +
        '?autoplay=1&rel=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="lazy" class="about-promise-bison__modal-iframe" title="Video"></iframe>'
      );
    }
    if (parsed.type === 'vimeo') {
      return (
        '<iframe src="https://player.vimeo.com/video/' +
        escapeAttr(parsed.id) +
        '?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy" class="about-promise-bison__modal-iframe" title="Video"></iframe>'
      );
    }
    if (parsed.type === 'video') {
      return (
        '<video src="' +
        escapeAttr(parsed.src) +
        '" class="about-promise-bison__modal-video" controls autoplay playsinline></video>'
      );
    }
    return (
      '<iframe src="' +
      escapeAttr(parsed.src) +
      '" allowfullscreen loading="lazy" class="about-promise-bison__modal-iframe" title="Video"></iframe>'
    );
  }

  function closeModal(modal, playBtn) {
    var content = modal.querySelector('.about-promise-bison__modal-content');
    if (content) content.innerHTML = '';
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (playBtn && typeof playBtn.focus === 'function') playBtn.focus();
  }

  function openModal(modal, playBtn, videoUrl) {
    var parsed = parseVideoUrl(videoUrl);
    if (!parsed) return;
    var content = modal.querySelector('.about-promise-bison__modal-content');
    if (!content) return;
    content.innerHTML = buildEmbed(parsed);
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('.about-promise-bison__modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function initSection(root) {
    if (root.getAttribute('data-promise-video-init') === 'true') return;
    var playBtn = root.querySelector('.about-promise-bison__play--modal');
    var modal = root.querySelector('.about-promise-bison__modal');
    if (!playBtn || !modal) return;
    root.setAttribute('data-promise-video-init', 'true');

    var videoUrl = playBtn.getAttribute('data-video-url') || '';
    var panel = modal.querySelector('.about-promise-bison__modal-panel');
    var closeBtn = modal.querySelector('.about-promise-bison__modal-close');

    playBtn.addEventListener('click', function () {
      openModal(modal, playBtn, videoUrl);
    });

    function onClose() {
      closeModal(modal, playBtn);
    }

    if (closeBtn) closeBtn.addEventListener('click', onClose);

    /* Close when clicking outside the popup (backdrop, gutter, or modal shell — not the panel). */
    modal.addEventListener('click', function (e) {
      if (panel && !panel.contains(e.target)) {
        onClose();
      }
    });
  }

  function onEscape(e) {
    if (e.key !== 'Escape') return;
    var modal = document.querySelector('.about-promise-bison__modal:not([hidden])');
    if (!modal) return;
    var root = modal.closest('.about-promise-bison');
    var playBtn = root ? root.querySelector('.about-promise-bison__play--modal') : null;
    closeModal(modal, playBtn);
  }

  function initAll() {
    document.querySelectorAll('.about-promise-bison[data-video-modal]').forEach(initSection);
  }

  if (!window.__aboutPromiseEscapeBound) {
    window.__aboutPromiseEscapeBound = true;
    document.addEventListener('keydown', onEscape);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target;
    if (!container || !container.querySelector) return;
    container.querySelectorAll('.about-promise-bison[data-video-modal]').forEach(initSection);
  });
})();
